import { Box, Link } from '@mui/material';

function ContactUsBox() {
  return (
    <Link
      href="https://www.scylladb.com/pricing#request-pricing"
      className="contact-us-link contact-us-text"
      target="_blank"
    >
      <Box className="contact-us-box">
        <h5>Annual Pricing</h5>
        <br />
        <span>Contact us {'>'}</span>
      </Box>
    </Link>
  );
}

export default ContactUsBox;
